(function () {
  'use strict';

  angular
    .module('checker')
    .directive('interactionDirective', function () {
      return {
        scope: {
          'interaction': '='
        },
        templateUrl: "./view_all_interactions/details.html"
      }
    });
})();